import { useState } from 'react';

import { toast } from 'react-toastify';

import { Container } from '../../../styles/Common';
import Loader from '../Loader';
import { InnerMain, Wrapper, AdminLogo, LogoutButton } from './Styles';
import { adminLogoutApi } from './../../../apis/index';
import { useNavigate } from 'react-router-dom';

const AdminNavbar = () => {
  const navigate = useNavigate();

  const [logoutIsLoading, setLogoutIsLoading] = useState<boolean>(false);

  const handleLogout = async () => {
    try {
      setLogoutIsLoading(true);
      await adminLogoutApi();
      navigate('/admin');
      setLogoutIsLoading(false);
    } catch (error: any) {
      setLogoutIsLoading(false);
      toast.error(error.response.data.message || 'Something went wrong.');
    }
  };

  return (
    <>
      <Wrapper>
        <Container>
          <InnerMain>
            <AdminLogo to="/admin/dashboard">Dashboard</AdminLogo>
            <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
          </InnerMain>
        </Container>
      </Wrapper>
      {logoutIsLoading && <Loader />}
    </>
  );
};

export default AdminNavbar;
